import * as Lucide from 'lucide-react';

// This registry maps our internal icon names (matching Material icon names)
// to the corresponding Lucide icon components.
// Includes all Blockdaemon-UI icons to maintain compatibility.
export const iconRegistry = {
  account_balance_wallet: Lucide.Wallet,
  add: Lucide.Plus,
  arrow_back: Lucide.ArrowLeft,
  arrow_drop_down: Lucide.ChevronDown,
  arrow_drop_up: Lucide.ChevronUp,
  arrow_forward: Lucide.ArrowRight,
  calendar_month: Lucide.Calendar,
  cancel: Lucide.XCircle,
  check: Lucide.Check,
  check_circle: Lucide.CheckCircle,
  chevron_left: Lucide.ChevronLeft,
  chevron_right: Lucide.ChevronRight,
  cloud_download: Lucide.Download,
  close: Lucide.X,
  content_copy: Lucide.Copy,
  copy_all: Lucide.Copy,
  credit_card: Lucide.CreditCard,
  dark_mode: Lucide.Moon,
  delete: Lucide.Trash2,
  deployed_code: Lucide.Code2,
  description: Lucide.FileText,
  edit: Lucide.Edit,
  error: Lucide.AlertOctagon,
  expand_less: Lucide.ChevronUp,
  expand_more: Lucide.ChevronDown,
  file_upload: Lucide.Upload,
  groups_2: Lucide.Users,
  info: Lucide.Info,
  keyboard_arrow_down: Lucide.ChevronDown,
  keyboard_arrow_up: Lucide.ChevronUp,
  light_mode: Lucide.Sun,
  lock_person: Lucide.Lock,
  logo_dev: Lucide.Code,
  logout: Lucide.LogOut,
  mail: Lucide.Mail,
  menu: Lucide.Menu,
  more_vert: Lucide.MoreVertical,
  notifications: Lucide.Bell,
  open_in_new: Lucide.ExternalLink,
  percent: Lucide.Percent,
  play_arrow: Lucide.Play,
  priority_high: Lucide.AlertCircle,
  refresh: Lucide.RefreshCw,
  remove: Lucide.Minus,
  report: Lucide.FileWarning,
  search: Lucide.Search,
  settings: Lucide.Settings,
  shield_person: Lucide.Shield,
  stop: Lucide.StopCircle,
  token: Lucide.Ticket,
  trending_down: Lucide.TrendingDown,
  trending_up: Lucide.TrendingUp,
  warning: Lucide.AlertTriangle,
  webhook: Lucide.Webhook,
  message: Lucide.MessageCircle,
  note_add: Lucide.FilePlus,
  event_note: Lucide.CalendarDays,
  code: Lucide.Code,
  upload_file: Lucide.Upload,
  photo_library: Lucide.Images,
  image: Lucide.Image,
  videocam: Lucide.Video,
  table_chart: Lucide.Table,
  cloud_upload: Lucide.UploadCloud,
  folder_open: Lucide.FolderOpen,
  account_circle: Lucide.UserCircle,
  folder: Lucide.Folder,
  photo_camera: Lucide.Camera,
  schema: Lucide.GitBranch,
  database: Lucide.Database,
  api: Lucide.Network,
  widgets: Lucide.LayoutGrid,
  edit_note: Lucide.FilePen,
  home: Lucide.Home,
  inventory: Lucide.Package,
  shopping_cart: Lucide.ShoppingCart,
  download: Lucide.Download,
  share: Lucide.Share2,
  person: Lucide.User,
  swap_horiz: Lucide.ArrowLeftRight,
  email: Lucide.Mail,
  lock: Lucide.Lock,
  admin_panel_settings: Lucide.ShieldCheck,
  key: Lucide.Key,
  vpn_key: Lucide.KeyRound,
  alternate_email: Lucide.AtSign,
  visibility: Lucide.Eye,
  phone: Lucide.Phone,
  feedback: Lucide.MessageCircle,
  sticky_note_2: Lucide.StickyNote,
  bug_report: Lucide.Bug,
  lock_open: Lucide.LockOpen,
  security: Lucide.ShieldCheck,
  verified: Lucide.CheckCircle2,
  star: Lucide.Star,
  keyboard_double_arrow_left: Lucide.ChevronsLeft,
  keyboard_double_arrow_right: Lucide.ChevronsRight,
  receipt_long: Lucide.Receipt,
  help: Lucide.HelpCircle,
  dashboard: Lucide.LayoutDashboard,
  analytics: Lucide.BarChart3,
  group: Lucide.Users,
  dots: Lucide.MoreVertical,
  file: Lucide.FileText,
  eye: Lucide.Eye,
  trash: Lucide.Trash2,
  file_image: Lucide.FileImage,
} as const;

export type IconName = keyof typeof iconRegistry;
export type LucideIcon = React.ComponentType<{
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  className?: string;
}>;
